import { OrderSummaryRelationships } from '../../../hooks/useOrderSummary';

export enum OrderDetailsItemsSectionName {
  OpenItems = 'Open Items',
  CancelledItems = 'Cancelled Items',
  ShippedItems = 'Shipped Items',
  ReturnRequestedItems = 'Return Requested Items',
  ReturnReceivedItems = 'Return Received Items',
  ReturnRejectedItems = 'Return Rejected Items',
  RefundedItems = 'Refunded Items'
}

export interface OrderDetailsItemsSectionProps {
  alternateTitle?: string;
  hasPaymentOption?: boolean;
  title: OrderDetailsItemsSectionName;
  propertyName: keyof OrderSummaryRelationships;
}

export const orderDetailsItemsSectionsConfig: OrderDetailsItemsSectionProps[] = [
  {
    alternateTitle: 'Select the items to pay the remaining balance',
    title: OrderDetailsItemsSectionName.OpenItems,
    hasPaymentOption: true,
    propertyName: 'openItems'
  },
  {
    title: OrderDetailsItemsSectionName.ShippedItems,
    propertyName: 'shippedItems'
  },
  {
    title: OrderDetailsItemsSectionName.CancelledItems,
    propertyName: 'cancelledItems'
  },
  {
    title: OrderDetailsItemsSectionName.ReturnRequestedItems,
    propertyName: 'returnRequestedItems'
  },
  {
    title: OrderDetailsItemsSectionName.ReturnReceivedItems,
    propertyName: 'returnReceivedItems'
  },
  { title: OrderDetailsItemsSectionName.ReturnRejectedItems, propertyName: 'returnRejectedItems' },
  {
    title: OrderDetailsItemsSectionName.RefundedItems,
    propertyName: 'refundedItems'
  }
];
